import { Injectable, signal } from "@angular/core";

// Tracks the release that answers the API. The frontend ships with the backend, so a release
// other than the first one means a deploy replaced the frontend that this tab runs. The lazy
// chunks of the old build are then gone, and the tab must reload to load the new build.
@Injectable({
    providedIn: "root",
})
export class AppReleaseService {
    private firstRelease: string | undefined;
    private readonly newVersion = signal(false);

    readonly newVersionAvailable = this.newVersion.asReadonly();

    observe(release: string): void {
        this.firstRelease ??= release;
        if (release !== this.firstRelease) {
            this.newVersion.set(true);
        }
    }
}
